import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./css/ElementDetacher.css";
import { DockPanelHandle } from "./DockPanel/DockPanel";

interface ElementDetacherProps {
    id: string;
    alternativeContent: React.ReactNode;
    dockPanel: React.RefObject<DockPanelHandle | null>;
    mustDock: boolean;
    children: React.ReactNode;
}

export const ElementDetacher: React.FC<ElementDetacherProps> = ({
    id,
    alternativeContent,
    dockPanel,
    mustDock,
    children
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [detached, setDetached] = useState(false);

    // Track the host element returned by DockPanel
    const hostRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
        if (!mustDock && detached && dockPanel?.current) {
            dockPanel.current.remove(id);
            hostRef.current = null;
            setDetached(false);
        }

        if (mustDock && !detached && dockPanel?.current) {
            // Ask DockPanel for a host element
            hostRef.current = dockPanel.current.getHostElement(id);
            setDetached(true);
        }
    }, [detached, dockPanel, id, mustDock]);

    return (
        <>
            <div ref={containerRef}
                className="ed-container">
                <div className={`ed-content ${detached ? "detached" : ""}`}>{children}</div>
            </div>

            {detached && hostRef.current &&
                ReactDOM.createPortal(
                    alternativeContent,
                    hostRef.current
                )}
        </>
    );
};
